import React from "react";

function NotFound() {
    return (<>
        <h3>404: route not found</h3>
    </>);
}

export default NotFound;
